module.exports = __webpack_public_path__ + "static/media/มะเส็ง.a488b0a1.jpg";